import axios from "axios";

const login = (params) => axios.post("auth/login", params);
const logout = (params) => axios.post("auth/logout", params);
const passwordRequest = (params) => axios.post("password/request", params);
const passwordReset = (params) => axios.post("password/reset", params);

export { login, logout, passwordRequest, passwordReset };
